<template>
  <div class="unusual" style="height:200px; position: relative;">
    <CustomTitle :title="titletxt" />
    <div class="chart-container">
      <div class="chart">
        <Echart id="pieAA" :options="option" height="100%" width="100%" />
      </div>
      <div class="legend-spacer"></div>
    </div>
    <div style="padding:0 42px">
      <div class="statistic">
        <div class="statistic-con">
          <div class="statistic-item">
            <span class="num">{{ errorNumOfTimer }}</span>
            {{txtunit}}
          </div>
          <div class="statistic-item">
            <span class="num">{{ errorQuantity }}</span>
            件
          </div>
          <div class="statistic-item">
            <span class="num">{{ errorPrice }}</span>
            元
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'
import config from '@/js/config'
import CustomTitle from '@/components/CustomTitle'
export default {
  name: 'Unusual',
  data () {
    return {
      avgNum: 0,
      sumpcs: 0,
      unit: '',
      txtunit: '次',
      opt: [],
      optunit: [],
      runpcs: -1,
      timer: '',
      allrun: 0,
      compid: -1,
      dept: '',
      ispro: 0,
      option: {},
      errorNumOfTimer: 0,
      errorQuantity: 0,
      errorPrice: 0,
      requestTimer: null,
      retryTimer: null,
      titletxt:'品质异常统计',
      requestUrl:'',
      legendScrollInterval: null
    }
  },
  components: {
    CustomTitle,
    Echart
  },
  created () {
    this.requestUrl = window.localStorage.getItem('requestUrl')
    this.dept = window.localStorage.getItem('bsmdept')
    this.ispro = window.localStorage.getItem('bsmisprodep')
    this.getqafun()
    this.starttime()
  },
  methods: {
    calculatePageSize() {
    // Get the chart DOM element
    const chartDom = document.getElementById('pieAA');
    if (!chartDom) return 5; // Default fallback
    
    // Get the computed height of the chart container
    const chartHeight = chartDom.clientHeight;
    
    // Calculate how many items can fit (each item takes approx. 30px with gaps)
    const itemHeightWithGap = 30; // 8px icon + 12px gap + 10px text
    const availableHeight = chartHeight * 0.8; // Use 80% of chart height for legend
    
    // Return the calculated page size, with minimum of 3 and maximum of 8
    return Math.min(8, Math.max(3, Math.floor(availableHeight / itemHeightWithGap)));
  },
    pieBtn (da) {
      const pageSize = this.calculatePageSize();
      const itemHeightWithGap = 30; 
      this.option = {
        color: ['#ffa631', '#955539', '#ffc773', '#eedeb0', '#ca6924', '#8c4356', '#ff4c00', '#b0a4e3'],
        grid: {
          containLabel: true
        },
        legend: {
          itemHeight: 8,
          itemWidth: 8,
          orient: 'vertical',
          show: true,
          itemGap: 12,
          right: '10px',
          top: 'middle',
          type: 'scroll',
          pageIconSize: 10,
          pageIconColor: '#2C86FF',
          pageIconInactiveColor: 'rgba(44,132,251,0.40)',
          pageTextStyle: {
            color: '#999',
            fontSize: 10
          },
          padding: [0, 5, 0, 5],
          formatter: (name) => {
            const total = da.reduce((pre, cur) => pre + cur.value, 0)
            const currentItem = da.find(item => item.name === name)
            const displayName = name.length > 6 ? name.substring(0, 6) + '...' : name
            return `{title|${displayName}} {valueColor|${currentItem.value}次 (${((currentItem.value / total) * 100).toFixed(0)}%)}`
          },
          textStyle: {
            rich: {
              title: {
                fontSize: 10,
                color: '#fff'
              },
              valueColor: {
                fontSize: 10,
                color: '#48E5E5'
              }
            }
          },         
        right: '10px',
        height: `${pageSize * itemHeightWithGap}px`,
        },
        series: [
          {
            type: 'pie',
            radius: '55%',
            center: ['25%', '48%'],
            label: {
              show: false
            },
            data: da
          }
        ]
      }
      this.$nextTick(() => this.setupLegendScroll())
    },
    
    setupLegendScroll() {
    clearInterval(this.legendScrollInterval);
    
    const pageSize = 3;
    let currentPage = 0;
    
    this.legendScrollInterval = setInterval(() => {
      const chart = this.$echarts.getInstanceByDom(document.getElementById('pieAA'));
      if (!chart) return;
      const totalItems = this.opt['异常数量'].length;
      const totalPages = Math.ceil(totalItems / pageSize);
      
      currentPage = (currentPage + 1) % totalPages;
      
      chart.dispatchAction({
        type: 'legendScroll',
        scrollDataIndex: currentPage * pageSize
      });
    }, 5000);
  },
   
  

    // ... keep your existing pieBtndept, pieBtnpcs methods unchanged ...

    getqafun() {
      clearTimeout(this.retryTimer)
      this.compid = window.localStorage.getItem('bsmcompid')
      this.dept = window.localStorage.getItem('bsmdept')
      this.axios({
        method: 'post',
        url: `${this.requestUrl}/admin.php/Bigsreen/QAdeptSumFun?datekind=1&compid=${this.compid}&dst=&ded=&kind=-1&dept=${this.dept}&ispro=${this.ispro}`
      })
      .then((Response) => {
        var qa = JSON.parse(Response.data)
        this.opt = qa
        this.unit = '件'
        this.pieBtn(this.opt['异常数量'])
        this.runpcs = 1

        this.errorNumOfTimer = qa['异常次数'].reduce((total, obj) => obj.value + total, 0)
        this.errorQuantity = qa['异常数量'].reduce((total, obj) => obj.value + total, 0)
        this.errorPrice = qa['异常金额'].reduce((total, obj) => obj.value + total, 0)
      })
      .catch((error) => {
        console.log(error + " Unusual")
        this.retryTimer = setTimeout(() => this.getqafun(), config.retryTime)
      })
    },

    starttime() {
      this.timer = setInterval(() => {
        if (this.runpcs < 0 || this.allrun > 60) {
          this.allrun = 0
        }

        if (this.runpcs === 0) {
          this.unit = '件'
          this.pieBtnpcs(this.opt['异常数量'])
          this.runpcs = 1
        } else {
          this.unit = '次'
          if(this.dept == "PMD") {
            this.pieBtndept(this.opt['异常次数'])
          } else {
            this.pieBtn(this.opt['异常次数'])
          }
          this.runpcs = 0
        }

        this.allrun = this.allrun + 1
      }, 30000)
    }
  },
  mounted() {
    this.requestTimer = setInterval(() => {
      if(this.dept == "PMD") {
        this.getdeptfun()
      } else {
        this.getqafun()
      }
    }, config.refreshTime.unusual)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.requestTimer)
    clearTimeout(this.retryTimer)
    clearInterval(this.legendScrollInterval)
  }
}
</script>

<style scoped lang="less">
.unusual {
  display: flex;
  flex-direction: column;
  
  .chart-container {
    display: flex;
    flex: 1;
    position: relative;
    
    .chart {
      flex: 1;
      width: calc(100% - 20px);
    }
    
    .legend-spacer {
      width: 20px;
      @media (max-width: 1366px) {
        width: 30px;
      }
    }
  }
  
  .statistic {
    padding: 0px 50px;
    height: 42px;
    background-image: url("~@/assets/images/bigscreenSales/title.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &-con {
      width: 100%;
      display: flex;
      justify-content: space-between;
      
      .statistic-item {
        font-family: "D-DIN";
        font-weight: 400;
        font-size: 12px;
        color: #c6d1db;
        
        .num {
          height: 30px;
          font-weight: 700;
          font-size: 24px;
          line-height: 30px;
          color: #f3f6fa;
          margin-right: 4px;
        }
      }
    }
  }
}

@media (max-width: 1366px) {
  .statistic {
    padding: 0 20px !important;
    
    &-item {
      font-size: 10px !important;
      
      .num {
        font-size: 18px !important;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/workroomdp/components/Unusual.vue